// extracted by mini-css-extract-plugin
export default {"invalid":"SelectPreferredTimeslots-module--invalid--39ogC"};